import React from 'react'
import { Button, Col, Form,Row, InputGroup } from 'react-bootstrap';
import Multiselect from 'multiselect-react-dropdown'; 
import { useCreateDas } from "./useCreateDas";
import { SearchIcon } from "../../../../components/ui/icons";
import TreeView from '../../../../components/treeView';
import CountySelectionFilter from '../../../../components/subscriptionRow/editSubscription/countySelectionFilter';

interface ChildProps {
  handleShow: () => void;
}

const CreateDAS :React.FC<ChildProps> = ({ handleShow }) => {
const { handleRadioChange, sendAutomatically,isTemplateDivSelected,handleTemplateClick,handleSubmit,handleAlertsSelect,handleAlertsRemove,alertsOptions,selectedAlertsOptions,handleGroupInputChange, groupSearchQuery, nodesToDisplay,handleDataFromTreeView,selectAllChecked,handleSelectAllChange,selectGroupState,setSelectGroupState,placedHolderAlertsValues,countyOptions,handleCountySelect,disableCountyValue,placedHolderCountyValues,selectedTotalOptions,selectedCountyOptions,selectedGroups,templateId,placedHolderGroupValues} = useCreateDas();
  
return (
    <>
    <Row>
        <Col sm={12}>
            <div className='integration-body'>
                <Col sm={6}>
                    <div className='integration-select'>
                        <Form.Label>Alert Types</Form.Label>
                            <Multiselect
                                displayValue="name"
                                hideSelectedList
                                onRemove={handleAlertsRemove}
                                onSelect={handleAlertsSelect}
                                options={alertsOptions}
                                showCheckbox
                                selectedValues={selectedAlertsOptions}
                                placeholder={placedHolderAlertsValues}
                            />
                    </div>
                </Col>

                <Col sm={6}>
                    <div className='integration-input-content'>
                        <div className='integration-input'>
                            <Form.Label htmlFor="cityType">County</Form.Label>
                            <CountySelectionFilter
                                handleCountySelect={handleCountySelect}
                                countyOptions={countyOptions}
                                selectedCountyOptions={selectedCountyOptions}
                                countyPlaceholder={placedHolderCountyValues}
                            />
                        </div>
                    </div>
                </Col>

                <Col sm={6}>
                <div className='select-group-container'>
                <div className="send-alerts-group-content">
                <label className="heading">Send Alerts to Group(s)</label>
                <div className="alerts-search-and-tree">
                <div className="alert-search-input">
                <InputGroup>
                  <Form.Control
                    placeholder={placedHolderGroupValues}
                    aria-label="Search"
                    aria-describedby="alert-search-input"
                    value={groupSearchQuery}
                    onChange={handleGroupInputChange}
                  />
                  <InputGroup.Text id="alert-search-input">
                    <SearchIcon />
                  </InputGroup.Text>
                </InputGroup>
                </div>
                <div className="alert-checkbox">
                <div className="select-all-checkbox">
                  <TreeView
                    nodes={nodesToDisplay}
                    onDataFromTreeView={handleDataFromTreeView}
                    isModalOrg={true}
                    isMultiSelect={true}
                    selectGroupState={selectGroupState} 
                    setSelectGroupState={setSelectGroupState}
                    isSelectAllEnabled={true}
                ></TreeView>
                </div>
                </div>
                </div>
            </div>
            </div>
            </Col>
                <Col sm={12}>
                    <div className='integration-radio'>
                        <Form.Label>Send Automatically?</Form.Label>
                        <Form.Check
                            inline
                            label="Yes"
                            name="group1"
                            type='radio'
                            checked={sendAutomatically}
                            onChange={() => handleRadioChange(true)}
                        />
                        <Form.Check
                            inline
                            label="No, needs approval."
                            name="group1"
                            type='radio'
                            checked={!sendAutomatically}
                            onChange={() => handleRadioChange(false)}
                        />
                    </div>
                </Col>
                <Col sm={12}>
                <h3 className='choosetemplate_heading'>Choose Template</h3>
                    <div className='choose-template-container'>
                    
                        <div className={`template ${isTemplateDivSelected(3) ? 'highlighted' : ''}`}
                        onClick={() => handleTemplateClick(3)}>
                            <div className='template-container'>
                                <div className='ticker'>
                                    <div className='template-text'>
                                        WARNING: Tornado inbound 3:00PM-6:00PM. Stay indoors unless you want to die.
                                    </div>
                                </div>
                            </div>
                                <div className='template-heading'>Ticker</div>
                        </div>

                        {/* <div className={`template ${isTemplateDivSelected(2) ? 'highlighted' : ''}`}
                        onClick={() => handleTemplateClick(2)}>
                            <div className='template-container'>
                                <div className='Overlay'>
                                    <div className='template-text'>
                                        WARNING: Tornado inbound 3:00PM-6:00PM. Stay indoors unless you want to die.
                                    </div>
                                </div>
                            </div>
                            <div className='template-heading'>Overlay</div>
                        </div> */}

                        <div className={`template ${isTemplateDivSelected(1) ? 'highlighted' : ''}`}
                        onClick={() => handleTemplateClick(1)}>
                            <div className='template-container'>
                                <div className='fullscreen'>
                                    <div className='template-text'>
                                        WARNING: Tornado inbound 3:00PM-6:00PM. Stay indoors unless you want to die.
                                    </div>
                                </div>
                            </div>
                            <div className='template-heading'>Fullscreen</div>
                        </div>
                    </div>
                </Col>
                <Col sm={12}>
                    <div className='integration-footer'> 
                        <Button disabled={!(selectedTotalOptions.length>0 && selectedCountyOptions.length>0 && selectedGroups.length>0 && templateId>0)} onClick={()=>{handleSubmit();handleShow();}}>Configure</Button>
                    </div>
                    <div className='integration-footer'> 
                        <Button onClick={handleShow}>Cancel</Button>
                    </div>
                </Col>
            </div>       
        </Col>
    </Row>
    </>
  )
}

export default CreateDAS